export default {
  init() {
    // JavaScript to be fired on the careers page
    $('form#career-search input#submit_btn').click( function(e) {
      e.preventDefault();
      let keyword = $('form#career-search input#keyword').val()
      if (keyword.length > 0) {
        $('#career-search .error:visible').css('display', 'none')
        let url = 'https://ekgn.fa.us6.oraclecloud.com/hcmUI/CandidateExperience/en/sites/CX_2001/requisitions?keyword=' + keyword;
        window.open(url, '_blank');
      } else {
        $('#career-search .error').css('display', 'block')
      }
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/careerSearch.js